//classe  che gestisce gli elementi primary
import React, { Component } from 'react';
import { BrowserRouter as Rrouter, Route, Switch } from 'react-router-dom';
import WelcomComponent from './Welcome/welcome';
import LoginComponent from './Login/loginComponent';
import clientiComponent from './Clienti/clienti';
import HeaderComponent from './Header/headerComponent';
import FooterComponent from './Footer/footerComponents';
import CancelloComponent from './Cancello/cancelloComponent';
import HomeComponent from './Home/homeComponent';
import LogoutComponent from './Logout/logoutComponent';
import AuthRouter from './AuthRouter';
import DatiClienteComponent from './Clienti/InserisciUtente/DatiCliente';
import DatiUteComponent from './Clienti/InserisciUtente/DatiUte';
import CancelloOnOffComponent from './CancelloOnOff/cancelloOnOffComponent';
import CaldaiaComponent from './Caldaia/caldaiaComponent';
import LuceComponent from './Luce/luceComponent';
import AlimComponent from './Alimentatore/alimComponent';
import CliTab from './Clienti/clitab'; 


export default class GestFidApp extends Component {
  componentDidMount() {
    window.addEventListener('beforeunload', this.handleLeavePage);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleLeavePage);
  }
  handleLeavePage(e) {
    //debugger;
    console.log('OUTPUT: GestFidApp -> handleLeavePage -> handleLeavePage', e);
    // const confirmationMessage = 'Some message';
    // e.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
    // return confirmationMessage; // Gecko, WebKit, Chrome <34
  }
  render() {
    return (
      <div className='GestFidApp mt-4'>
        <Rrouter>
          <HeaderComponent />
          <Switch>
            <Route path='/' exact component={HomeComponent}></Route>
            <Route path='/login/:call' component={LoginComponent}></Route>
            {/* <Route path='/clienti' component={clientiComponent}></Route> */}
            {/* <AuthRouter
              path='/insutente/:id'
              render={(props) => <kkk {...props} />}
              component={DatiClienteComponent}
              nome={'cld'}
              cognome={'ina'}
              state='zzzzzzzzzzzzz'
            /> */}
            <AuthRouter
              path='/utente'
              component={clientiComponent}
            ></AuthRouter>
            <AuthRouter
              path='/insutente/:id'
              component={DatiClienteComponent}
            ></AuthRouter>
            <AuthRouter
              path='/insute'
              component={DatiUteComponent}
            ></AuthRouter>

            <Route path='/logout' component={LogoutComponent}></Route>
            <Route path='/welcome' component={WelcomComponent}></Route>
            <Route path='/clitab' component={CliTab}></Route>
            
            <AuthRouter
              path='/welcome/:userid'
              component={WelcomComponent}
            ></AuthRouter>

            <AuthRouter
              path='/cancello'
              component={CancelloComponent}
            ></AuthRouter>

            <AuthRouter
              path='/cancello1'
              component={CancelloOnOffComponent}
            ></AuthRouter>
            <AuthRouter
              path='/caldaia'
              component={CaldaiaComponent}
            ></AuthRouter>
            <AuthRouter
              path='/luce'
              component={LuceComponent}
            ></AuthRouter>
              
              <AuthRouter
              path='/alim'
              component={AlimComponent}
            ></AuthRouter>


            <Route component={errorComponent}></Route>
          </Switch>
        </Rrouter>
        <FooterComponent />
      </div>
    );
  }
}

function errorComponent() {
  return (
    <div className='HomeComponent'>
      <div className='row mr-0'>
        <div className='col-md-12 py-5  d-flex flex-column justify-content-center'>
          <div className='row'>
            <div className='col-lg-6 col-md-8 mx-auto'>
              {/* <div className='card rounded shadow shadow-sm'> */}
              <div className='card-body'>
                <div className='jumbotron'>
                  <h1 className='display-5'>
                    <b>Pagina non Trovata</b>
                  </h1>
                  <p className='lead'>Domotica</p>
                  <p>404</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

//! componente figlio login
